import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import img1 from "../assests/images/unnamed.webp";
import { Contextfirst } from "..";
import axios from "axios";
import { server } from "..";
import toast from "react-hot-toast";

const navLinks = [
  { display: "Home", url: "/home" },
  { display: "Subscription", url: "/subscription" },
  { display: "Resources", url: "/videos" },
  { display: "Feedback", url: "/feedback" },
];

const NavItems = ({ authentication, onLogout }) => (
  <>
    <ul className="m-0 flex list-none items-center gap-1 p-0 max-lg:w-full max-lg:flex-col max-lg:items-stretch max-lg:gap-1.5">
      {navLinks.map((item) => (
        <li key={item.url}>
          <NavLink
            to={item.url}
            className={({ isActive }) =>
              `inline-flex items-center rounded-full px-3.5 py-2 font-display text-[0.95rem] font-medium no-underline transition max-lg:w-full max-lg:px-4 max-lg:py-3.5 max-lg:text-[1.05rem] ${
                isActive
                  ? "bg-brand-soft text-brand-teal-dark"
                  : "text-brand-forest hover:bg-brand-soft hover:text-brand-teal-dark"
              }`
            }
          >
            {item.display}
          </NavLink>
        </li>
      ))}
    </ul>

    <div className="ml-2 flex items-center gap-2 max-lg:ml-0 max-lg:w-full max-lg:flex-col">
      <Link
        to="/divein"
        className="inline-flex items-center justify-center rounded-full bg-brand-teal px-[1.15rem] py-2.5 font-display text-sm font-semibold text-white no-underline transition hover:-translate-y-px hover:bg-brand-teal-dark max-lg:w-full max-lg:py-3.5"
      >
        Dive In
      </Link>
      {authentication ? (
        <button
          type="button"
          onClick={onLogout}
          className="inline-flex items-center justify-center rounded-full border-[1.5px] border-brand-forest/15 bg-transparent px-4 py-2 font-display text-sm font-semibold text-brand-forest transition hover:border-brand-teal hover:bg-brand-soft hover:text-brand-teal-dark max-lg:w-full max-lg:py-3.5"
        >
          Logout
        </button>
      ) : (
        <Link
          to="/login"
          className="inline-flex items-center justify-center rounded-full border-[1.5px] border-brand-forest/15 bg-transparent px-4 py-2 font-display text-sm font-semibold text-brand-forest no-underline transition hover:border-brand-teal hover:bg-brand-soft hover:text-brand-teal-dark max-lg:w-full max-lg:py-3.5"
        >
          Login
        </Link>
      )}
    </div>
  </>
);

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { authentication, Setauthentication, Setuser } = useContext(Contextfirst);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;

    // The drawer is hidden by CSS past the lg breakpoint, so it must not keep the page locked.
    const close = () => setMenuOpen(false);
    document.body.style.overflow = "hidden";
    window.addEventListener("resize", close);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("resize", close);
    };
  }, [menuOpen]);

  const Logout = () => {
    axios
      .get(`${server}/users/logout`, { withCredentials: true })
      .then(() => {
        Setauthentication(false);
        toast.success("Logged Out");
        navigate("/");
        Setuser("");
      })
      .catch(() => {
        Setauthentication(true);
      });
  };

  if (location.pathname === "/") return null;

  return (
    <header
      className={`sticky top-0 z-[1000] flex h-[72px] items-center border-b border-brand-forest/5 backdrop-blur-[14px] transition ${
        scrolled ? "bg-white/95 shadow-[0_8px_30px_rgba(10,43,30,0.06)]" : "bg-white/80"
      }`}
    >
      <Container>
        <div className="flex min-h-[72px] w-full items-center justify-between gap-4">
          <Link to="/home" className="inline-flex items-center gap-2.5 no-underline">
            <img src={img1} alt="EzShiksha logo" className="h-12 w-12 object-contain" />
            <p className="m-0 font-display text-[1.35rem] font-bold leading-none tracking-tight text-brand-forest">
              Ez<span className="text-brand-teal">Shiksha</span>
            </p>
          </Link>

          <nav className="hidden items-center gap-1.5 lg:flex">
            <NavItems authentication={authentication} onLogout={Logout} />
          </nav>

          <button
            type="button"
            className="border-0 bg-transparent p-1.5 leading-none lg:hidden"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <i className={`text-[1.55rem] text-brand-forest ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>
      </Container>

      {/* Rendered outside the blurred header so the fixed drawer covers the viewport. */}
      {createPortal(
        <>
          <div
            className={`fixed inset-0 z-[1090] bg-brand-forest/45 transition-opacity duration-200 lg:hidden ${
              menuOpen ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />
          <nav
            className={`fixed right-0 top-0 z-[1100] flex h-screen w-[min(320px,86vw)] flex-col items-stretch gap-5 bg-white px-6 pb-8 pt-[5.5rem] shadow-[-12px_0_40px_rgba(10,43,30,0.12)] transition-transform duration-200 lg:hidden ${
              menuOpen ? "translate-x-0" : "translate-x-full"
            }`}
            aria-hidden={!menuOpen}
          >
            <NavItems authentication={authentication} onLogout={Logout} />
          </nav>
        </>,
        document.body
      )}
    </header>
  );
};

export default Header;
